var React = require('react');
var moment = require('moment');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step4;
var { $simpleSelect, $input, $datePicker } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');
var dataService = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx');

class ActiveLicenses extends React.Component {
    constructor(props) {
        super(props);

        this.addLicense = this.addLicense.bind(this);
        this.deleteLicense = this.deleteLicense.bind(this);
        this.getLicensesMarkup = this.getLicensesMarkup.bind(this);
        this.handleInputChangeForRecord = this.handleInputChangeForRecord.bind(this);
        this.incrementLicenseCount = this.incrementLicenseCount.bind(this);
        this.decrementLicenseCount = this.decrementLicenseCount.bind(this);
        this.state = {
            licenseCount: this.props.stepState.activeLicenses.length
        }
    }



    getLicensesMarkup() {
        return this.props.stepState.activeLicenses.map(function (item, index) {
            return <div key={index}>
                <div className={"field-wrap"}>
                    <label>{labels.step4.state}</label>
                    <$simpleSelect
                        value={item.state}
                        selectdatafunction={selectableDataFunctions.getMedicalLicenseStates}
                        valueprop="StateCode"
                        labelprop="StateDescription"
                        name="state"
                        selectoptions="statesByCountry"
                        data-recordid={item.id}
                        onChange={this.handleInputChangeForRecord}
                        validations={[validationFunctions.required]} />
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step4.startDate}</label>
                    <$datePicker
                        value={item.startDate && moment.utc(item.startDate).isValid() ? moment.utc(item.startDate).format('YYYY-MM-DD') : ""}
                        onInput={this.handleInputChangeForRecord}
                        name="startDate"
                        type="date"
                        date-format="yyyy-mm-dd"
                        data-recordid={item.id}
                        validations={[validationFunctions.required, validationFunctions.date, validationFunctions.dateNotInTheFuture]} />
                </div>
                <a href="#/" className={"alt-button"} data-recordid={item.id} data-fromapi={item.fromApi} onClick={this.deleteLicense}>{labels.step4.deleteLicense}</a>
                <hr className={"divider"} />
            </div>;
        }.bind(this));
    }

    incrementLicenseCount() {
        this.setState((state) => {
            if ((state.licenseCount + 1) > 1) {
                document.querySelector('#btnAddLicense').value = labels.step4.addAdditionalLicense; 
            }
            return { licenseCount: state.licenseCount + 1 }
        });
    }

    decrementLicenseCount() {
        this.setState((state) => {
            if ((state.licenseCount - 1) < 1) {
                document.querySelector('#btnAddLicense').value = labels.step4.addLicense;
            }
            return { licenseCount: state.licenseCount - 1 }
        });
    }

    getBlankLicenseRecord() {
        return {
            id: dataService.getNextId(),
            state: '',
            startDate: '',
            expireDate: ''
        }
    }

    addLicense() {
        this.props.pushNewRecord('activeLicenses', this.getBlankLicenseRecord());
        this.props.recenterScreen('.active-license-container');
        this.incrementLicenseCount();
    }

    deleteLicense(event) {
        this.props.deleteRecord('activeLicenses', event.target.dataset.recordid, !event.target.dataset.fromapi);
        this.props.recenterScreen('.active-license-container');
        this.decrementLicenseCount();
    }

    handleInputChangeForRecord(event) {
        // update the record in this field with the same id
        this.props.updateStepStateRecord('activeLicenses',
            event.target.name,
            event.target.value,
            event.target.dataset.recordid);
    }

    render() {
        if (memberTypeChecker.hideActiveLicenses(this.props.appState.appType)) {
            return null;
        }

        var addLicenseText;

        if (this.state.licenseCount > 0) {
            addLicenseText = labels.step4.addAdditionalLicense;
        }

        else {
            addLicenseText = labels.step4.addLicense;
        }

        const licenseLabel = this.props.stepState.activeLicenses && this.props.stepState.activeLicenses.length === 0
            ? <label className="license-required">{labels.step4.licenseRequired}</label> :
            null;

        return <div className={"active-license-container"}>

            <div className={"row"}>

                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step4.activeLicenses}</h3>

                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>

                            {this.getLicensesMarkup()}

                            <a href="#/" id="btnAddLicense" className={"button"} onClick={this.addLicense}>{addLicenseText}</a>
                            {licenseLabel}
                        </div>
                    </div>

                </div>

            </div>

        </div>;
    }
}

module.exports = ActiveLicenses;